import React, { useEffect, useState, useRef, useCallback } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { useTranslation } from "react-i18next";
import ProfileWithBackButtonHeader from "../header/ProfileWithBackButtonHeader";
import SectionHeaderBlogs from "../header/SectionHeaderBlogs";
import LoadingBar from "../LoadingBar";

const categories = [
  { id: 93, name: "PR & Promotion" },
  { id: 96, name: "Tourists" },
  { id: 6410, name: "Special" },
  { id: 6416, name: "Big Cook" },
  { id: 6405, name: "Social trends" },
  { id: 6420, name: "Tourist" },
];

const BlogDetailByCategory = () => {
  const { id } = useParams();
  const { t, i18n } = useTranslation();

  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const observer = useRef();

  const category = categories.find((cat) => String(cat.id) === id);
  const categoryName = category ? category.name : "";

  const fetchBlogs = async (pageNumber = 1) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BIGC_BIGLINE_API_URL}/blogs/blogs_categories`,
        {
          status: "publish",
          orderby: "date",
          order: "desc",
          per_page: 10,
          page: pageNumber,
          categories: id,
          language: i18n.language.toUpperCase(),
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_BIGC_BIGLINE_API_KEY,
          },
        }
      );

      const result = response.data.map((blog) => ({
        ...blog,
        friendlyURL: `${blog.link
          .replace("https://blog-corporate.bigc.co.th/", "/blogs/")
          .replace(/\/$/, "")}?id=${blog.id}`,
      }));

      setBlogs((prev) => [...prev, ...result]);

      if (result.length < 10) setHasMore(false);
    } catch (error) {
      console.error(`Error loading category ${categoryName}`, error);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };

  // รีเซตเมื่อ id หรือ ภาษาเปลี่ยน
  useEffect(() => {
    setBlogs([]);
    setPage(1);
    setHasMore(true);
  }, [id, i18n.language]);

  useEffect(() => {
    if (hasMore) {
      fetchBlogs(page);
    }
  }, [page]);

  const lastBlogElementRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, hasMore]
  );

  return (
    <>
      <ProfileWithBackButtonHeader />
      <div className="bg-[#f6f6f6] w-full px-5 xs:px-2 pb-6">
        <SectionHeaderBlogs
          className="py-4"
          name={t("blogs")}
          eventSection={true}
          seniorLayout={false}
        />
        <div className="mb-10">
          <h2 className="text-xl font-semibold text-gray-800 mb-3">
            {categoryName}
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-4 xs:gap-3">
          {blogs.map((blog, index) => {
            const isLast = index === blogs.length - 1;

            return (
              <div
                key={blog.id}
                ref={isLast ? lastBlogElementRef : null}
                className="w-full"
              >
                <a href={blog.friendlyURL} className="no-underline block">
                  {/* กรอบรูป: สี่เหลี่ยมจัตุรัสเสมอ */}
                  <div
                    className="w-full overflow-hidden rounded-md bg-white shadow-sm"
                    style={{ aspectRatio: "16 / 9" }}
                  >
                    <img
                      src={
                        blog.image ||
                        "https://linebc.bigc.co.th/images/placeholder-1200x1200.jpg"
                      }
                      alt={blog.title.rendered}
                      className="w-full h-full object-cover block"
                      loading="lazy"
                    />
                  </div>

                  {/* ชื่อเรื่อง */}
                  <div className="pt-2 text-gray-800">
                    <div
                      className="px-2 line-clamp-2 font-medium text-[12px] sm:text-[14px] leading-tight
               whitespace-normal break-words text-left"
                      dangerouslySetInnerHTML={{ __html: blog.title.rendered }}
                    />
                  </div>
                </a>
              </div>
            );
          })}
        </div>

        {loading && (
          <div className="pt-4">
            <LoadingBar loading={loading} label="Loading..." />
          </div>
        )}
      </div>
    </>
  );
};



export default BlogDetailByCategory;